import { cdnRoot } from "@pepdirect/v3/constants/assets";

// Root of the poppi static-asset mirror on the shared S3 bucket; every
// scraped brand asset URL in the app derives from this.
export const assetsRoot = `${cdnRoot}/static-images/poppi`;

// GTM web container (public container id; bootstrap in _app, noscript
// fallback in _document).
export const gtmContainerId = "GTM-T3TBRN9";

export const environment = process.env.NEXT_PUBLIC_PROJECT_ENV || "";
export const tenant = process.env.NEXT_PUBLIC_TENANT || "";
export const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENV || "";
export const isProductionReady = ["staging", "production", "uat"].includes(
  environment
);
export const isLocalEnv = !isProductionReady && !process.env.CI;

export const decovoShopAppId = "b0414f96-89ee-4a2d-94ea-9b062d2a7212";
export const sentryDSN = process.env.NEXT_PUBLIC_SENTRY_DSN || "";

export const imgWidths = [345, 600, 690];

export const shipping = {
  us: {
    free: 0,
    below: "0",
    threshold: 1000000000000000000000000,
  },
};

export const cart = {
  discounts: {
    hideDiscountsMaxThreshold: 2,
    showSavingsMaxThreshold: 10,
  },
  maxCartQty: 15,
};

export const cookies = {
  localStorageUserKey: "caps_user",
  cartCookieName: "decovo-shoppingcart",
  secureCookie: isProductionReady,
  zipCode: "user-zip-code",
};

export const endpoints = {
  cdn: process.env.NEXT_PUBLIC_CDN_URL || "",
  productsImgCdn: process.env.NEXT_PUBLIC_IMG_CDN_ROOT || "",
  web: process.env.NEXT_PUBLIC_WEB_ROOT || "",
  api: process.env.NEXT_PUBLIC_API_ROOT || "",
  cart: process.env.NEXT_PUBLIC_CART_ROOT || "",
  checkout: process.env.NEXT_PUBLIC_CHECKOUT_ROOT || "",
  portalService: process.env.NEXT_PUBLIC_PORTAL_SERVICE_ROOT || "",
  portalFrontend: process.env.NEXT_PUBLIC_PORTAL_FRONTEND_ROOT || "",
  corporateFrontend: process.env.NEXT_PUBLIC_CORPORATE_FRONTEND_ROOT || "",
  graphqlBackend: process.env.NEXT_PUBLIC_GRAPHQL_ROOT || "",
  internalApi: process.env.NEXT_INTERNAL_API_ROOT || "",
  datoCmsEndpoint: process.env.NEXT_PUBLIC_DATOCMS_ENDPOINT || "",
};

export const headerPromotion = {
  shouldShow: true,
  isAlwaysVisible: true,
};

export const links = {
  contact: "https://contact.pepsico.com/poppi",
};
